"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonEmptyArrayError = void 0;
const tslib_1 = require("tslib");
const index_1 = require("./index");
tslib_1.__exportStar(require("io-ts"), exports);
tslib_1.__exportStar(require("io-ts-types"), exports);
tslib_1.__exportStar(require("io-ts-reporters"), exports);
const nonEmptyArrayError = (at, expected) => {
    const values = (0, index_1.pipe)(expected, index_1.array.map(index_1.string.doubleQuotes), index_1.monoid.concatAll(index_1.string.join(' | ')));
    return `Expecting NonEmptyArray<(${values})> at ${at} but instead got: []`;
};
exports.nonEmptyArrayError = nonEmptyArrayError;
//# sourceMappingURL=iots.js.map